import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  root: {},
  label: {
    margin: theme.spacing(2, 0),
    textAlign: 'center',
  },
});

const EmergencyFundOutcomeSummaryStepLayout = ({
  className,
  classes,
}) => {
  const { resource } = useMetaLayoutContext();

  const monthlyTarget = resource.meta().field('target').options().list()
    .find(opt => opt.id() === resource.attr('adjustment'))
    ?.attr('prompt');

  const totalBalanceTarget = resource.meta().field('adjustedTotal').options().list()
    .find(opt => opt.id() === resource.attr('adjustment'))
    ?.attr('prompt');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        test={'emergency-fund-monthly-target'}
        className={classes.label}
        variant="h2"
      >
        {monthlyTarget}
      </Typography>
      <Typography
        test={'emergency-fund-total-balance-target'}
        className={classes.label}
        variant="h2"
      >
        {totalBalanceTarget}
      </Typography>
      <MetaField attr="adjustment" />
    </Box>
  );
};

EmergencyFundOutcomeSummaryStepLayout.defaultProps = {
  className: '',
};

EmergencyFundOutcomeSummaryStepLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EmergencyFundOutcomeSummaryStepLayout);
